
export const About = () => {
    return (
        <section id="about" className="resume">
            <div className="container">
                <div className="section-title">
                    <h2>About me</h2>
                    <p> Hello there, I'm <strong>Axel Clerget</strong> aka <strong><em>Striker</em></strong> and I am a <strong>Technical designer</strong>.</p>
                    <br/>
                    <p>
                        Driven by a passion for game development, I enjoy exploring every aspect of game creation, from design and programming to production. Here, you'll find a collection of projects, tools and prototypes I've contributed to along the way.
                    </p>
                    <br/>
                    <p>
                        Alongside my full-time job, I run <strong><a href="https://revolt-studios.com" target="_blank">REVOLT</a></strong>, my own independent game development label, where I pursue personal projects and explore new creative opportunities. <br/>
                        Interested in my profile or looking to collaborate? Feel free to get in touch!
                    </p>
                    {/*
                    <br/>
                    <p>
                        Want to know more about my professional experience and my studies? <a href="#resume" className="btn btn-primary btn-sm">More info</a>.
                    </p>
                    */}
                </div>
            </div>
        </section>
    )
}